import { signout } from '@features/common';
import { addClicked } from '../../page';
import {
  $addRelation,
  $errorRelated,
  clearError,
  errorOccured,
  fxRelatedSave,
  setAddRelation,
} from '../model';

$addRelation
  .on(setAddRelation, (_, status) => status)
  .reset([addClicked, fxRelatedSave.done, signout]);

$errorRelated
  .on(errorOccured, (_, { error }) => JSON.parse(error.message ?? '{}'))
  .reset([signout, clearError]);
